import { Link } from "react-router-dom"
import styled, { css } from "styled-components"

export default function ConfirmCenterModal({ id, whiteboxRef, dataList, onComplete, onCancel }) {
  return (
    <WhiteBox ref={whiteboxRef}>
      <ModalContentBlock>
        {dataList?.title && <ModalTitle>{dataList.title}</ModalTitle>}
        {dataList?.description && <ModalDesc>{dataList.description}</ModalDesc>}
        <ButtonListBlock>
          {onCancel && (
            <CancelBtn onClick={() => onCancel(id)}>
              {dataList?.cancelTxt ? dataList.cancelTxt : "취소"}
            </CancelBtn>
          )}
          {dataList?.path ? (
            <LinkBtn to={dataList?.path}>
              {dataList?.confirmTxt ? dataList.confirmTxt : "확인"}
            </LinkBtn>
          ) : (
            <CompleteBtn onClick={() => onComplete(id)}>
              {dataList?.confirmTxt ? dataList.confirmTxt : "확인"}
            </CompleteBtn>
          )}
        </ButtonListBlock>
      </ModalContentBlock>
    </WhiteBox>
  )
}

const WhiteBox = styled.div`
  width: calc(100vw * (284 / 375));
  border-radius: calc(100vw * (10 / 375));
  background: #fff;
  overflow: hidden;
`

const ModalContentBlock = styled.div`
  width: 100%;
  padding-top: calc(100vw * (27 / 375));
  padding-bottom: calc(100vw * (20 / 375));
  padding-left: calc(100vw * (24 / 375));
  padding-right: calc(100vw * (24 / 375));
`

const ModalTitle = styled.h3`
  font-size: calc(100vw * (18 / 375));
  font-weight: 700;
  color: #121212;
  text-align: center;
  margin-bottom: calc(100vw * (13 / 375));
`

const ModalDesc = styled.p`
  font-size: calc(100vw * (14 / 375));
  line-height: calc(100vw * (20 / 375));
  color: #4e4e4e;
  text-align: center;
  white-space: pre-wrap;
  margin-bottom: calc(100vw * (22 / 375));
`

const ButtonListBlock = styled.div`
  display: flex;
`

const buttonStyle = css`
  width: 100%;
  padding: calc(100vw * (10 / 375));
  color: #121212;
  border-radius: calc(100vw * (8 / 375));
  font-weight: 500;
  background: #ffcf19;
`

const LinkBtn = styled(Link)`
  ${buttonStyle};
  text-align: center;
  line-height: normal;
`

const CompleteBtn = styled.button`
  ${buttonStyle};
`

const CancelBtn = styled.button`
  ${buttonStyle};
  background: #efefef;
  color: #4e4e4e;
  margin-right: calc(100vw * (9 / 375));
`
